import { RegistrationPanel } from '../components/RegistrationPanel.js';

document.addEventListener('DOMContentLoaded', () => {
    const authPanel = new RegistrationPanel();

    // Bind Play Buttons (Author Page specific)
    const playButtons = document.querySelectorAll<HTMLElement>('.btn-play');
    playButtons.forEach((btn: HTMLElement) => {
        btn.addEventListener('click', (e: Event) => {
            e.preventDefault();
            authPanel.open();
        });
    });
});
